
// CUSTOM TESTIMONAKL SLIDER

  
  var elem = document.querySelector('.js-custom--testimonials-slider');
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'center',
    contain: true
  });
  


  /////END CUSTOM TESTIMONIALS SLIDER  